var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var getFnString = function (fnBody, fnParams) {
    return "function _RT_ ({".concat(fnParams.join(','), "}) {").concat(fnBody, "}");
};
export default function (_a) {
    var _b;
    var env = _a.env, data = _a.data, inputs = _a.inputs, outputs = _a.outputs, logger = _a.logger, onError = _a.onError;
    var fns = data.fns, runImmediate = data.runImmediate;
    var runJSParams = { outputs: outputs };
    try {
        if (runImmediate) {
            if (env.runtime) {
                eval(decodeURIComponent(fns))(runJSParams);
            }
        }
        inputs.input0(function (val) {
            var _a;
            try {
                eval(decodeURIComponent(fns))(__assign(__assign({}, runJSParams), { inputValue: val }));
            }
            catch (ex) {
                onError === null || onError === void 0 ? void 0 : onError(ex.message);
                env.edit ? console.error('js计算组件运行错误.', ex) : (_a = env.logger) === null || _a === void 0 ? void 0 : _a.error("".concat(ex));
            }
        });
    }
    catch (ex) {
        onError === null || onError === void 0 ? void 0 : onError(ex.message);
        env.edit ? console.error('js计算组件运行错误.', ex) : (_b = env.logger) === null || _b === void 0 ? void 0 : _b.error("".concat(ex));
    }
}
